import React from 'react';
import AuthAdminUserModel from '../../code/models/AuthAdminUserModel';
import AdminBidPackagesImportForm from './AdminBidPackagesImportForm';
import AdminBidPackagesTripChange from './AdminBidPackagesTripChange';
import AdminBidPackagesIETrips from './AdminBidPackagesIETrips';
import '../../css/adminbidpackagesform.css';

interface IAdminBidPackagesForm {
    adminUser: AuthAdminUserModel;
}

export default function AdminBidPackagesForm({ adminUser }: IAdminBidPackagesForm) {
    const [currentPage, setCurrentPage] = React.useState<string>("bidpack");

    React.useEffect(() => { }, []);

    function selectPage(page: string) {
        setCurrentPage(page);
    }

    function getTabClassName(tabInfo: string) {
        switch (currentPage + tabInfo) {
            case currentPage + currentPage: return "nav-link active";
            default: return "nav-link";
        }
    }
    const bidPackPage: string = "bidpack";
    const tripChanges: string = "tripchange";
    const ieTrips: string = "ietrips";

    return (
        <React.Fragment>
            <div className="bidpack-form">
                <ul className="nav nav-tabs">
                    <li className="nav-item">
                        <a className={getTabClassName(bidPackPage)} href="#" onClick={() => selectPage(bidPackPage)}>Import Bid Packs</a>
                    </li>
                    <li className="nav-item">
                        <a className={getTabClassName(tripChanges)} href="#" onClick={() => selectPage(tripChanges)}>Trip Changes</a>
                    </li>
                    <li className="nav-item">
                        <a className={getTabClassName(ieTrips)} href="#" onClick={() => selectPage(ieTrips)}>IE Trips</a>
                    </li>
                </ul>
            </div>

            {currentPage === bidPackPage && <AdminBidPackagesImportForm />}
            {currentPage === tripChanges && <AdminBidPackagesTripChange />}
            {currentPage === ieTrips && <AdminBidPackagesIETrips />}
        </React.Fragment >
    )
}

